import { render, staticRenderFns } from "./ItemList.vue?vue&type=template&id=c50b23fe&scoped=true"
import script from "./ItemList.vue?vue&type=script&lang=js"
export * from "./ItemList.vue?vue&type=script&lang=js"
import style0 from "./ItemList.vue?vue&type=style&index=0&id=c50b23fe&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c50b23fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c50b23fe')) {
      api.createRecord('c50b23fe', component.options)
    } else {
      api.reload('c50b23fe', component.options)
    }
    module.hot.accept("./ItemList.vue?vue&type=template&id=c50b23fe&scoped=true", function () {
      api.rerender('c50b23fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ItemList.vue"
export default component.exports